import { memo } from 'react'
import { ArrowLeft } from 'lucide-react'
import './BackNavButton.css'

interface BackNavButtonProps {
  label: string
  onClick: () => void
  /** On narrow viewports, show icon only (label stays available to assistive tech). */
  compactOnNarrow?: boolean
  className?: string
  'data-testid'?: string
  /** Analytics event identity. Pass a page-specific `<area>-back` name; defaults to `nav-back`. */
  'data-analytics-event'?: string
}

export default memo(function BackNavButton({
  label,
  onClick,
  compactOnNarrow,
  className = '',
  'data-testid': testId,
  'data-analytics-event': analyticsEvent = 'nav-back',
}: BackNavButtonProps) {
  return (
    <button
      type="button"
      className={['back-nav-btn', compactOnNarrow ? 'back-nav-btn--compact-sm' : '', className].filter(Boolean).join(' ')}
      onClick={onClick}
      data-testid={testId}
      data-analytics-event={analyticsEvent}
    >
      <ArrowLeft className="back-nav-btn__icon" size={16} strokeWidth={1.75} aria-hidden />
      <span className="back-nav-btn__label">{label}</span>
    </button>
  )
})
